<template>
  <section class="section section-hero section-shaped my-0">
    <div class="shape shape-style-1 shape-primary"></div>
    <div>
      <div class="container text-center" style="margin-top: 50px;">
        <template>
          <img src="img/brand/logo.png" style="width:110px; height:110px;" />
          <h2 style="font-style: italic;">Enter your mobile number</h2>
        </template>
        <template>
          <VuePhoneNumberInput v-model="phone_number" @update="phone_number_update" />
          <!-- <b-form-input v-model="phone_number" placeholder="Enter your Phone Number"></b-form-input> -->
          <loading :active.sync="phone_verifying" :is-full-page="true" loader="dots"></loading>

          <b-alert
            class="mt-3"
            :show="phone_error_countdown"
            dismissible
            variant="danger"
            @dismissed="phone_error_countdown=0"
            @dismiss-count-down="countDownChanged"
          >
            <p>Phone signup failed! This error message will be disappear within {{ phone_error_countdown }} seconds...</p>
          </b-alert>
        </template>
        <template>
          <div class="row mt-5" style="justify-content: center;">
            <b-button
              v-b-modal.phone_verify
              block
              variant="success"
              size="lg"
              style="width: 200px;"
              @click="SignupPhone()"
            >Continue</b-button>
          </div>
        </template>

        <b-modal
          id="modal_phone_verify"
          header-class="text-center"
          title-class="title-fill"
          hide-footer
        >
          <template v-slot:modal-title>
            <img src="img/brand/logo.png" style="width:110px; height:110px;" />
            <h2 style="font-style: italic;">Enter your mobile number</h2>
          </template>
          <template>
            <div class="text-center">
              <CodeInput
                :loading="false"
                class="code-check"
                v-on:change="onCodeChange"
                v-on:complete="onCodeComplete"
              />
            </div>
            <div class="mt-3">
              <b-alert v-model="check_code_alert" variant="danger" dismissible>
                <p>Wrong verification code!</p>
                <b-button variant="light" size="sm">Resend code</b-button>
              </b-alert>
            </div>
          </template>
          <template>
            <div class="row mt-3" style="justify-content: center;">
              <b-button
                block
                variant="success"
                size="lg"
                @click="verifyPhone()"
                :disabled="!check_fill"
                style="width: 200px;"
              >Continue</b-button>
            </div>
          </template>
        </b-modal>
      </div>
    </div>
  </section>
</template>

<script>
import Modal from "@/components/Modal.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import CodeInput from "vue-verification-code-input";

const axios = require("axios");
export default {
  name: "components",
  components: {
    Modal,
    VuePhoneNumberInput,
    Loading,
    CodeInput,
  },
  data() {
    return {
      phone_number_withCountry: "",
      phone_number: "",
      dismissSecs: 5,
      phone_error_countdown: 0,
      phone_verifying: false,
      phone_verify_code: "",
      input_verify_code: "",
      check_fill: false,
      check_code_alert: false,
    };
  },
  mounted() {},
  methods: {
    phone_number_update(param) {
      // console.log(param);
      this.phone_number_withCountry = param.formattedNumber;
    },
    SignupPhone() {
      var vm = this;
      vm.phone_verifying = true;
      var payload = {
        phone: vm.phone_number_withCountry,
        message: "Phone Signup",
        key:
          "aeba5d92f8b3f65d26fba928fafb01e65d01fc81L3tmxfPUb2tYC8VIbM6ARaOP9",
      };
      // Using axios
      axios
        .post("https://textbelt.com/otp/generate", {
          phone: vm.phone_number_withCountry,
          userid: "walther.schulze@alpha-innomed.com",
          key:
            "aeba5d92f8b3f65d26fba928fafb01e65d01fc81L3tmxfPUb2tYC8VIbM6ARaOP9",
        })
        .then((response) => {
          vm.phone_verifying = false;
          if (response.data.success == true) {
            vm.phone_verify_code = response.data.otp;
            vm.$bvModal.show("modal_phone_verify");
            //Check api success or not
            //     window.location.href = "#/account";
          } else {
            vm.showAlert();
          }
          // console.log(response.data);
        });

      // axios.post("https://textbelt.com/text", payload).then((response) => {
      //   console.log(response.data);
      //   if (response.data.success == true) {
      //     //Check api success or not

      //     vm.phone_verifying = false;
      //     window.location.href = "#/account";
      //   } else {
      //     vm.showAlert();
      //   }
      // });
    },
    verifyPhone() {
      var vm = this;
      // console.log(this.phone_verify_code);
      // console.log(this.input_verify_code);

      if (this.phone_verify_code == this.input_verify_code) {
        var matches = this.phone_number_withCountry.match(/(\d+)/);
        console.log(matches[0]);
        let payload = {
          phone: matches[0],
        };
        axios
          .post(
            "http://zorion.alpha-innomed.com:4040/api/auth/registerphone",
            payload
          )
          .then(function (response) {
            // handle success
            console.log(response);
            console.log(response.data);
            vm.$store.dispatch("storeSignupType", "phone");
            vm.$store.dispatch("storeToken", response.data.token);
            window.location.href =
              "#/account?phone=" +
              vm.phone_number_withCountry.match(/(\d+)/)[0];
          })
          .catch(function (error) {
            // handle error
            console.log(error);
            vm.$store.dispatch("clearSignupType");
            vm.$store.dispatch("clearToken");
            vm.$router.push({ name: "register" });
          });
      } else {
        this.check_code_alert = true;
      }
    },
    countDownChanged(phone_error_countdown) {
      this.phone_error_countdown = phone_error_countdown;
    },
    showAlert() {
      this.phone_error_countdown = this.dismissSecs;
    },
    onCodeChange(v) {
      // console.log("onChange ", v);
    },
    onCodeComplete(v) {
      // console.log("onComplete ", v);
      this.input_verify_code = v;
      this.check_fill = true;
    },
  },
};
</script>
<style scoped>
.code-check {
  display: contents;
}
</style>